const track = {
  options: [],
  selectedTrack: {},
  isLoading: false,
};

export default track;
